<template>
  <div class="text-center">
    <v-card class="list-area-box">
      <v-list class="list-area">
        <v-list-item>
          <v-list-item-title>신청구분</v-list-item-title>
          <v-list-item-subtitle> {{ codeNm }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>기준일자</v-list-item-title>
          <v-list-item-subtitle> {{ ymd }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>기준일자 근무유형</v-list-item-title>
          <v-list-item-subtitle> {{ workOrgNm }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>신청사유</v-list-item-title>
          <v-list-item-subtitle> {{ note }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>신청단위</v-list-item-title>
          <v-list-item-subtitle> {{ dayGubunNm }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>근무기간</v-list-item-title>
          <v-list-item-subtitle>
            {{ date }}
            <v-btn
              @click="openModal('work_schedule_time')"
              block
              elevation="0"
              class="btn-outline-white"
              >상세보기</v-btn
            ></v-list-item-subtitle
          >
        </v-list-item>
        <v-list-item>
          <v-list-item-title>비상연락망</v-list-item-title>
          <v-list-item-subtitle> {{ phoneNo }} </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card>
    <work-schedule-time-calendar v-bind:appInfoParam="appInfoParam" />
  </div>
</template>
<script>
import {
  getWorkScheduleAppDetWorkOrg,
  getWorkScheduleDetail,
} from '@/api/workStatus';
import { mapMutations } from 'vuex';
import WorkScheduleTimeCalendar from '@/components/calendar/WorkScheduleTimeCalendar.vue';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **
import { getUiInfo } from '@/api/approvalCommon';

export default {
  mixins: [dialogMixin],
  data: () => ({
    codeNm: '',
    ymd: '',
    workOrgNm: '',
    note: '',
    dayGubunNm: '',
    date: '',
    phoneNo: '',
  }),
  props: {
    appInfoParam: Object,
  },
  computed: {
    ...mapMutations('DIALOG', ['SET_DIALOG_PARAM', 'TOGGLE_MODAL']),

    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_NAV
      }px`;
    },
  },

  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),

    openModal(modalNm) {
      this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
    },
  },

  async created() {
    let response = await getWorkScheduleDetail(this.appInfoParam);

    let params = {
      ymd: response.data.data.ymd.replaceAll('-', ''),
    };

    response = await getWorkScheduleAppDetWorkOrg(params);
    // console.log('response1 ::: ' + JSON.stringify(response));
    this.workOrgNm = response.data.data.workOrgNm;

    this.appInfoParam.dayGrcodeCd = response.data.data.dayGrcodeCd;
    response = await getWorkScheduleDetail(this.appInfoParam);
    // console.log('response2 ::: ' + JSON.stringify(response));

    this.codeNm = response.data.data.codeNm;
    this.ymd = response.data.data.ymd;
    this.note = response.data.data.note;
    this.dayGubunNm = response.data.data.dayGubunNm;
    this.date = response.data.data.sdate + ' ~ ' + response.data.data.edate;
    this.phoneNo = response.data.data.phoneNo;

    response = await getUiInfo(this.appInfoParam);
    console.dir(response);

    if (response.data.data.fileYn === 'N') {
      this.$emit('showFileView', false);
    } else {
      this.$emit('showFileView', true);
    }

    this.OFF_APP_SPINNER();
  },

  components: { WorkScheduleTimeCalendar },
};
</script>
